const _ = require('lodash')

export default {
  computed: {
    age_groups: function () {
      return this.$store.state.data.Main ? this.$store.state.data.Main.age_groups : null
    },
    roomData: function () {
      return this.$store.state.data.Room
    }

  },
  watch: {
    '$route.params.title': function (title) {
      this.reset()
    }
  },
  props: ['orgdata', 'group', 'index', 'keyname', 'is_new'],
  methods: {
    updatemedia: function (event) {
      this.data.uploadedmedia = event.target.files[0]
      this.mediabutton = event.target
    },
    save: function () {
      const app = this
      this.$store.dispatch('addMediaToRoom', { content: this.data })
        .then((response) => {
          app.$emit('stringUpdated', app.index, app.data)
          if (!app.index) {
            window.setTimeout(app.reset, 0)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    deleteString: function () {
      this.$emit('stringDeleted', this.index, this.data)
    },
    log: function (item) {
      console.log(item)
    },
    reset: function () {
      if (this.index == null) {
        // runs when it is a new string, not from db
        console.log(this.orgdata, this.startdata)
        if (this.orgdata) {
          this.data = { ...this.startdata, ..._.clone(this.orgdata) }
        } else {
          this.data = _.clone(this.startdata)
          if (this.group) {
            this.data.group = this.group
          }
        }
      } else {
        // from db
        this.data = _.clone(this.orgdata)
      }
      if (this.mediabutton) {
        this.mediabutton.value = null
      }
    },
    removeMedia: function () {
      this.data.media = null
    }
  }
}
